import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthContext } from '@/features/auth/AuthProvider';
import type { UserRole } from '@/store/authSlice';

interface Props {
  roles?: UserRole[];
}

/** Guards routes: redirects to /login if unauthenticated; enforces roles. */
export default function ProtectedRoute({ roles }: Props): JSX.Element {
  const { isAuthenticated, bootstrapping, user } = useAuthContext();
  const location = useLocation();

  if (bootstrapping) {
    return (
      <div className="flex min-h-full items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-600 border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (roles && user && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
